module.exports = __webpack_public_path__ + "static/media/home_core_collection_btn.ff126e31.png";